export class ValidateTenderResponse {
  public isValid: boolean;
}